import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ResourceTableBody from '@presentational/ResourceTableBody';
import ResourceTableHeaders from '@presentational/ResourceTableHeaders';
import { ta } from 'utils';

import ItemLink from '@presentational/ItemLink';
import { transactionHistoryShape } from 'utils/shapeProps';

import join from 'lodash/join';

const propTypes = {
  transferURLBase: PropTypes.string.isRequired,
  saleReportURLBase: PropTypes.string,
  transactions: transactionHistoryShape.isRequired,
  transactionTotalsMoney: PropTypes.arrayOf(PropTypes.string).isRequired,
  isSeller: PropTypes.bool.isRequired,

  variantLogsURLBase: PropTypes.string,

  displayTransferColumn: PropTypes.bool,
  displaySaleReportColumn: PropTypes.bool, // if true will display link to parent SaleReport (useful for views oustide SaleReport#show)
}

const defaultProps = {
  displayTransferColumn: true,
  displaySaleReportColumn: false,
}

// I18n.l("time.formats.long", )
const SaleReportTransactionsHistory = (props) => {

  const buildSkuCell = (data) => {
    if(props.variantLogsURLBase && data.product_id) {
      return (
        <ItemLink
          url={ props.variantLogsURLBase.replace("VARIANT_ID", data.variant_id).replace("PRODUCT_ID", data.product_id) }
          content={ data.sku }
        />
      );
    }
    else{
      return data.sku
    }
  }

  // The column goes in both datasets
  // BUT it appears if props.displayTransferColumn is true.
  const apuColumn = !props.displayTransferColumn ? null : {
    size: 1, 
    header: "Entrega APU", tooltip: I18n.t("dashboard.transfer.tooltip.origin"),
    accessor: (data) => <ItemLink url={ props.transferURLBase.replace("URL_ID", data.transfer_origin_id) } content={ data.transfer_origin_name } />
  };

  const saleReportColumn = !props.displaySaleReportColumn ? null : {
    size: 1,
    header: I18n.t("activerecord.models.sale_report.one"),
    accessor: (data) => {
      return <ItemLink url={ props.saleReportURLBase.replace("URL_ID", data.sale_report_id) } content={ data.sale_report_name } />
    }
  };

  let columnsDataDraft = null;
  if(props.isSeller) {

    columnsDataDraft = [
      // size 1 optional saleReport column if props.displaySaleReportColumn is true
      // size 1 optional apuColumn column if props.displayTransferColumn is true
      { size: 2, header: ta("products_transfer.variant_sku"), accessor: buildSkuCell },
      { size: 1, header: ta("general.quantity"), accessor: "quantity" },
      { size: 2, header: "Movimiento", accessor: (data) => I18n.t(`enum.kind.display_audit_trail.${data.kind}`) },
      { size: 1, header: "ID", accessor: "bright_pearl_order_id" },
      { size: 2, header: ta("sale_report_item.order_date"), accessor: (data) => I18n.l("time.formats.long", data.goods_note_date)  },
      { size: 2, header: "Costo + IVA", accessor: "amount_money" },
    ];

    let extraColumn = false;
    if(apuColumn) {
      columnsDataDraft.unshift(apuColumn); // index 0
      extraColumn = true;
    } 
    if(saleReportColumn){
      columnsDataDraft.unshift(saleReportColumn); // index 0
      extraColumn = true;
    }
    
    if(!extraColumn){ // optional columns does not exist, thus the space must be redistributed.
      columnsDataDraft[1]["size"] += 1; // Quantity size 2
      columnsDataDraft[4]["size"] += 1; // Order date size 3
    }

  } 
  else {
    columnsDataDraft = [
      { size: 2, header: "Proveedor", accessor: "vendor" },
      // size 1 optional saleReport column if props.displaySaleReportColumn is true
      // size 1 optional apuColumn column if props.displayTransferColumn is true
      { size: 1, header: ta("products_transfer.variant_sku"), accessor: buildSkuCell },
      { size: 1, header: ta("general.quantity"), accessor: "quantity" },
      { size: 1, header: "Movimiento", accessor: (data) => I18n.t(`enum.kind.display_audit_trail.${data.kind}`) },
      { size: 1, header: "ID", accessor: "bright_pearl_order_id" },
      { size: 2, header: ta("sale_report_item.order_date"), accessor: (data) => I18n.l("time.formats.long", data.goods_note_date)  },
      { size: 2, header: "Costo + IVA", accessor: "amount_money" },
    ]

    if(apuColumn){
      columnsDataDraft.splice(1, 0, apuColumn);
    }

    if(saleReportColumn){
      columnsDataDraft.splice(1, 0, saleReportColumn);
    }
  }
  
  const columnsData = columnsDataDraft;
  const colSizeForTotalValue = columnsData.at(-1).size; // size of last column
  const colSizeForTotalText = 12 - colSizeForTotalValue;

  console.log("CD", columnsData);

  return (
    <div>
      <ResourceTableHeaders
        columnsInfo={ columnsData }
      />
      <ResourceTableBody
        columnsInfo={ columnsData }
        items={ props.transactions }
        itemURL={null}
      />

      <div className="container-fluid pv15 bg-gray mb40">
        <div className="row">

          <div className={`col-md-${colSizeForTotalText}`}>
            Total
          </div>
          <div className={`col-md-${colSizeForTotalValue}`}>
            { join(props.transactionTotalsMoney, " y ") }
          </div>

        </div>
      </div>
    </div>
  )
};

SaleReportTransactionsHistory.propTypes = propTypes;
SaleReportTransactionsHistory.defaultProps = defaultProps;

export default SaleReportTransactionsHistory;